/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Style_Guide_Loaded_MessageInputs */



/**
* | output |
* | --- |
* | "Style guide loaded successfully" |
*
* @param {Iframe_Remote_Style_Guide_Loaded_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_loaded_message = /** @type {((inputs?: Iframe_Remote_Style_Guide_Loaded_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Loaded_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide de style charge avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Styleguide erfolgreich geladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida di stile caricata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Руководство по стилю успешно загружено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía de estilo cargada exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("样式指南已成功加载")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドが正常に読み込まれました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड सफलतापूर्वक लोड हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guia de estilo carregado com sucesso")
	return /** @type {LocalizedString} */ ("Style guide loaded successfully")
});